import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { FootnotesPipe, RouterLinkDirective } from '@hyundai/ng-common-lib';
import { M000C010ImageComponent } from '../../000-primitives/m000-c010-image/m000-c010-image.component';
import { M010C020IconLinkComponent } from '../../010-buttons-and-links/m010-c020-icon-link/m010-c020-icon-link.component';
import { TeaserListItem } from './m030-c150-teaser-list.interface';

@Component({
    selector: 'ui-m030-c150-teaser-list',
    standalone: true,
    templateUrl: './m030-c150-teaser-list.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M000C010ImageComponent, M010C020IconLinkComponent, RouterLinkDirective, FootnotesPipe],
})
export class M030C150TeaserListComponent {
    data = input<TeaserListItem[]>();
    headline = input<string>();
}
